import React from "react";
import { useTranslation } from "react-i18next";

import { Graph } from "./graph";
import { Props } from "./types";
import styles from "./styles.scss";

function format(x: string) {
  const parts = x.toString().split(".");

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return parts.join(".");
}

function toFixed(num: number | string) {
  const nbr = typeof num === "string" ? parseFloat(num) : num;

  return typeof num !== "undefined" && num !== ""
    ? Math.round(nbr) === nbr
      ? nbr.toString()
      : nbr.toFixed(2)
    : "";
}

function CostsBreakdownByResourceType({ synthesis }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.costsBreakdownByResourceType}>
      <div className={styles.col}>
        <div className={styles.graph}>
          <Graph synthesis={synthesis} />
        </div>
      </div>
      <div className={styles.col}>
        <p className={styles.title}>
          {t("projectBudgetSynthesis.costsBreakdownByResourceType.costs")}
        </p>
        <div className={styles.row}>
          <div
            className={styles.legend}
            style={{ backgroundColor: "#FDA439" }}
          />
          <p className={styles.name}>
            {t("projectBudgetSynthesis.costsBreakdownByResourceType.external")}
          </p>
          <p className={styles.cost}>
            {format(
              toFixed(synthesis.plannedValueOfExternalResourcesOfProject),
            )}{" "}
            €
          </p>
        </div>
        <div className={styles.row}>
          <div
            className={styles.legend}
            style={{ backgroundColor: "#CBDDF7" }}
          />
          <p className={styles.name}>
            {t("projectBudgetSynthesis.costsBreakdownByResourceType.internal")}
          </p>
          <p className={styles.cost}>
            {format(
              toFixed(synthesis.plannedValueOfInternalResourcesOfProject),
            )}{" "}
            €
          </p>
        </div>
        <div className={styles.row}>
          <div
            className={styles.legend}
            style={{ backgroundColor: "#FD742E" }}
          />
          <p className={styles.name}>
            {t("projectBudgetSynthesis.costsBreakdownByResourceType.material")}
          </p>
          <p className={styles.cost}>
            {format(
              toFixed(synthesis.plannedValueOfMaterialResourcesOfProject),
            )}{" "}
            €
          </p>
        </div>
      </div>
    </div>
  );
}

export { CostsBreakdownByResourceType };
